import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
// Icons
import '@fortawesome/fontawesome-free/css/fontawesome.min.css';
import '@fortawesome/fontawesome-free/css/regular.min.css';
import '@fortawesome/fontawesome-free/css/solid.min.css';
// Main styles for this application
import '../static/css/style.css';
// Custom styles for this application
import '../static/css/custom.css';
import '../static/css/projects.css';
import '../static/css/tasks.css';
import '../static/css/widgets.css';
import '../static/css/bootstrap-custom.css';
import '../static/css/bootstrap-select-custom.css';



// WEBPACK FOOTER //
// ./src/style.js